<template>
  <g>
    <rect width="60" height="50" rx="10" ry="10"
    :fill="endInfo.status?'#de2922':'rgb(240, 173, 78)'">
    </rect>
    <text transform="translate(30,30)" text-anchor="middle"
     fill="white">{{endInfo.name}}</text>
  </g>
</template>
<script>
export default {
  name: 'process-end',
  props: {
    endInfo: {
      type: Object,
      default() {
        return {
          name: '开始',
          status: 0, // 0 开始 1 结束
        };
      },
    },
  },
};
</script>
